let env = "development";
if (process.env && process.env.VUE_APP_ENVIRONMENT) {
  env = process.env.VUE_APP_ENVIRONMENT.trim().toLowerCase();
}

export const environment: "development" | "production" = env as "development" | "production";
